import { render } from "./HeroiconsSolidArrowLeft.vue?vue&type=template&id=6b10d9ce"
const script = {}

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowLeft.vue"]])

export default __exports__